import { render, staticRenderFns } from "./ShortcutsHelp.vue?vue&type=template&id=49ef75f8&scoped=true&"
import script from "./ShortcutsHelp.vue?vue&type=script&lang=ts&"
export * from "./ShortcutsHelp.vue?vue&type=script&lang=ts&"
import style0 from "./ShortcutsHelp.vue?vue&type=style&index=0&id=49ef75f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ef75f8",
  null
  
)

export default component.exports